
export const words = {
  m3: {
    // Drive - Positive (→High)
    commanding: 'Commanding',
    decisive: 'Decisive',
    dominant: 'Dominant',
    assertive: 'Assertive',
    bold: 'Bold',
    direct: 'Direct',
    ambitious: 'Ambitious',
    influential: 'Influential',
    proactive: 'Proactive',
    // Drive - Negative (→Low)
    accommodating: 'Accommodating',
    cooperative: 'Cooperative',
    agreeable: 'Agreeable',
    supportive: 'Supportive',
    humble: 'Humble',
    diplomatic: 'Diplomatic',
    collaborative: 'Collaborative',
    gentle: 'Gentle',
    modest: 'Modest',
    // Connection - Positive
    sociable: 'Sociable',
    expressive: 'Expressive',
    outgoing: 'Outgoing',
    enthusiastic: 'Enthusiastic',
    friendly: 'Friendly',
    warm: 'Warm',
    engaging: 'Engaging',
    charismatic: 'Charismatic',
    animated: 'Animated',
    // Connection - Negative
    reserved: 'Reserved',
    private: 'Private',
    quiet: 'Quiet',
    reflective: 'Reflective',
    solitary: 'Solitary',
    introverted: 'Introverted',
    contemplative: 'Contemplative',
    observing: 'Observing',
    introspective: 'Introspective',
    // Task - Positive
    steady: 'Steady',
    patient: 'Patient',
    consistent: 'Consistent',
    calm: 'Calm',
    methodical: 'Methodical',
    reliable: 'Reliable',
    stable: 'Stable',
    composed: 'Composed',
    deliberate: 'Deliberate',
    // Task - Negative
    urgent: 'Urgent',
    fastPaced: 'Fast-paced',
    dynamic: 'Dynamic',
    restless: 'Restless',
    quick: 'Quick',
    impatient: 'Impatient',
    impetuous: 'Impetuous',      // NEW: replaced spontaneous duplicate
    hasty: 'Hasty',              // NEW: replaced adaptable
    impulsive: 'Impulsive',      // NEW: replaced energetic
    // Order - Positive
    systematic: 'Systematic',
    organized: 'Organized',
    structured: 'Structured',
    precise: 'Precise',
    meticulous: 'Meticulous',
    detailed: 'Detailed',
    accurate: 'Accurate',
    disciplined: 'Disciplined',
    thorough: 'Thorough',
    // Order - Negative
    informal: 'Informal',
    casual: 'Casual',
    creative: 'Creative',
    relaxed: 'Relaxed',
    easygoing: 'Easygoing',
    versatile: 'Versatile',
    flexible: 'Flexible',
    unconventional: 'Unconventional',
    unplanned: 'Unplanned',      // NEW: replaced spontaneousF duplicate
    // Style - Positive
    analytical: 'Analytical',
    logical: 'Logical',
    dataDriven: 'Data-driven',
    rational: 'Rational',
    objective: 'Objective',
    factual: 'Factual',
    reasoned: 'Reasoned',
    critical: 'Critical',
    skeptical: 'Skeptical',      // NEW: replaced evidenceBased duplicate
    // Style - Negative
    intuitive: 'Intuitive',
    feelingOriented: 'Feeling-oriented',
    emotional: 'Emotional',
    instinctive: 'Instinctive',
    empathetic: 'Empathetic',
    imaginative: 'Imaginative',
    compassionate: 'Compassionate',
    sentimental: 'Sentimental',
    heartfelt: 'Heartfelt',      // NEW: replaced visionary
  },
  m2: {
    // Drive
    authoritative: 'Authoritative',
    commanding: 'Commanding',
    forceful: 'Forceful',
    influential: 'Influential',
    decisive: 'Decisive',
    assertive: 'Assertive',
    direct: 'Direct',
    firm: 'Firm',
    strongWilled: 'Strong-willed',
    confident: 'Confident',
    ambitious: 'Ambitious',
    proactive: 'Proactive',
    independent: 'Independent',
    selfAssured: 'Self-assured',
    goalOriented: 'Goal-oriented',
    // Connection
    expressive: 'Expressive',
    sociable: 'Sociable',
    enthusiastic: 'Enthusiastic',
    vibrant: 'Vibrant',
    animated: 'Animated',
    friendly: 'Friendly',
    warm: 'Warm',
    engaging: 'Engaging',
    personable: 'Personable',
    communicative: 'Communicative',
    approachable: 'Approachable',
    welcoming: 'Welcoming',
    interactive: 'Interactive',
    affable: 'Affable',
    gregarious: 'Gregarious',
    // Task
    composed: 'Composed',
    tranquil: 'Tranquil',
    steady: 'Steady',
    unflappable: 'Unflappable',
    poised: 'Poised',
    gentle: 'Gentle',
    balanced: 'Balanced',
    evenTempered: 'Even-tempered',
    accommodating: 'Accommodating',
    flexible: 'Flexible',
    thoughtful: 'Thoughtful',
    considerate: 'Considerate',
    understanding: 'Understanding',
    peaceful: 'Peaceful',
    supportive: 'Supportive',
    // Order
    organized: 'Organized',
    systematic: 'Systematic',
    structured: 'Structured',
    methodical: 'Methodical',
    rigorous: 'Rigorous',
    procedural: 'Procedural',
    detailed: 'Detailed',
    thorough: 'Thorough',
    careful: 'Careful',
    precise: 'Precise',
    professional: 'Professional',
    proper: 'Proper',
    conventional: 'Conventional',
    traditional: 'Traditional',
    orderly: 'Orderly',
    // Style
    dataDriven: 'Data-driven',
    reasoned: 'Reasoned',
    impartial: 'Impartial',
    evidenceBased: 'Evidence-based',
    cerebral: 'Cerebral',
    calculated: 'Calculated',
    rationalMinded: 'Rational-minded',
    factFocused: 'Fact-focused',
    measured: 'Measured',
    reflective: 'Reflective',
    perceptive: 'Perceptive',
    feelingOriented: 'Feeling-oriented',
    passionate: 'Passionate',
    instinctive: 'Instinctive',
    sentimental: 'Sentimental'
  },
  behavioral: {
    dominant: 'Dominant',
    bold: 'Bold',
    assertive: 'Assertive',
    commanding: 'Commanding',
    powerful: 'Powerful',
    courageous: 'Courageous',
    daring: 'Daring',
    determined: 'Determined',
    competitive: 'Competitive',
    resolute: 'Resolute',
    formidable: 'Formidable',
    eager: 'Eager',
    relentless: 'Relentless',
    outstanding: 'Outstanding',
    dignified: 'Dignified',
    social: 'Social',
    engaging: 'Engaging',
    charismatic: 'Charismatic',
    convincing: 'Convincing',
    popular: 'Popular',
    sympathetic: 'Sympathetic',
    charming: 'Charming',
    pleasant: 'Pleasant',
    talkative: 'Talkative',
    esteemed: 'Esteemed',
    exciting: 'Exciting',
    lively: 'Lively',
    appealing: 'Appealing',
    outgoing: 'Outgoing',
    communicative: 'Communicative',
    patient: 'Patient',
    reasonable: 'Reasonable',
    content: 'Content',
    persistent: 'Persistent',
    relaxed: 'Relaxed',
    serene: 'Serene',
    tolerant: 'Tolerant',
    consistent: 'Consistent',
    calm: 'Calm',
    agreeable: 'Agreeable',
    stable: 'Stable',
    respectful: 'Respectful',
    unobtrusive: 'Unobtrusive',
    easyGoing: 'Easy-going',
    harmonious: 'Harmonious',
    neat: 'Neat',
    understanding: 'Understanding',
    contemplative: 'Contemplative',
    conventional: 'Conventional',
    polished: 'Polished',
    formal: 'Formal',
    precise: 'Precise',
    accurate: 'Accurate',
    factual: 'Factual',
    disciplined: 'Disciplined',
    orderly: 'Orderly',
    principled: 'Principled',
    observant: 'Observant',
    meticulous: 'Meticulous',
    objective: 'Objective',
    analytical: 'Analytical',
    logical: 'Logical',
    systematic: 'Systematic',
    rational: 'Rational',
    methodical: 'Methodical',
    detached: 'Detached',
    realistic: 'Realistic',
    pragmatic: 'Pragmatic',
    critical: 'Critical',
    empirical: 'Empirical',
    emotional: 'Emotional',
    intuitive: 'Intuitive',
    impulsive: 'Impulsive',
    anxious: 'Anxious',
    spontaneous: 'Spontaneous',
    // Additional Model 1 words
    cooperative: 'Cooperative',
    cheerful: 'Cheerful',
    generous: 'Generous',
    passive: 'Passive',
    quiet: 'Quiet',
    modest: 'Modest',
    laidBack: 'Laid-back',
    reliable: 'Reliable',
    evenPaced: 'Even-paced',
    gracious: 'Gracious',
    reserved: 'Reserved',
    lenient: 'Lenient',
    perfectionist: 'Perfectionist',
    tactful: 'Tactful',
    cautious: 'Cautious',
    conscientious: 'Conscientious',
    diligent: 'Diligent',
    conservative: 'Conservative',
    compliant: 'Compliant',
    thorough: 'Thorough',
    detailed: 'Detailed',
    careful: 'Careful',
    organized: 'Organized',
    dataDriven: 'Data-driven',
    evidenceBased: 'Evidence-based',
    rationalMinded: 'Rational-minded',
    factFocused: 'Fact-focused',
    feelingOriented: 'Feeling-oriented',
    sentimental: 'Sentimental',
    perceptive: 'Perceptive',
    reflective: 'Reflective',
    calculated: 'Calculated',
    cerebral: 'Cerebral',
    reasoned: 'Reasoned',
    impartial: 'Impartial',
    measured: 'Measured',
    passionate: 'Passionate',
    instinctive: 'Instinctive',
    accommodating: 'Accommodating',
    sociable: 'Sociable',
    friendly: 'Friendly',
    balanced: 'Balanced'
  }
};
